import type { Project } from '@/types'

export interface Publication {
  slug: string
  title: string
  year: number
  citation: string
  bibtex: string
  content: string
  venue?: string
  authors?: string
  abstract?: string
  keywords?: string
  paperLink?: string
}

export interface BlogPost {
  slug: string
  title: string
  date: string
  summary: string
  draft: boolean
  tags: string[]
  content: string
}

// Get all publications from generated JSON
export async function getAllPublications(): Promise<Publication[]> {
  try {
    const response = await fetch('/data/publications.json')
    if (!response.ok) {
      throw new Error('Failed to fetch publications')
    }
    return await response.json()
  } catch (error) {
    console.error('Error loading publications:', error)
    return []
  }
}

// Get all blog posts from generated JSON
export async function getAllBlogPosts(): Promise<BlogPost[]> {
  try {
    const response = await fetch('/data/blog-posts.json')
    if (!response.ok) {
      throw new Error('Failed to fetch blog posts')
    }
    return await response.json()
  } catch (error) {
    console.error('Error loading blog posts:', error)
    return []
  }
} 

// Get all projects from generated JSON
export async function getAllProjects(): Promise<Project[]> {
  try {
    const response = await fetch('/data/projects.json')
    if (!response.ok) {
      throw new Error('Failed to fetch projects')
    }
    return await response.json()
  } catch (error) {
    console.error('Error loading projects:', error)
    return []
  }
}